import PersonalPane from "./PersonalPane";

export default PersonalPane;
